import Button from 'components/Button/Button';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsUpdatingProjectStatus } from 'store/projects/selectors/projectsSelectors';
import { updateProjectStatus } from 'store/projects/thunks/updateProjectStatus.thunk';
import { ArchiveProjectDialog } from '../ArchiveProjectDialog/ArchiveProjectDialog';
import Icon from '@mdi/react';
import { mdiArchiveOutline } from '@mdi/js';

export const ArchiveProject = ({ project, classes }) => {
  const dispatch = useDispatch();

  const isUpdatingProjectStatus = useSelector(selectIsUpdatingProjectStatus);

  const { t } = useTranslation('common');

  const [isArchiveProjectDialogOpen, setIsArchiveProjectDialogOpen] =
    useState(false);

  const handleArchiveProject = () => {
    setIsArchiveProjectDialogOpen(false);
    dispatch(
      updateProjectStatus({
        projectId: project.id,
        status: 'ARCHIVED',
      })
    );
  };

  return project.businessTypeEnum !== 'EMPLOYER' &&
    project.type !== 'SHORT_TERM' ? (
    <div
      style={{
        width: '100%',
        textAlign: 'right',
        marginBottom: '15px',
      }}
    >
      {project.status !== 'ARCHIVED' ? (
        <Button
          
          onClick={() => setIsArchiveProjectDialogOpen(true)}
          disabled={isUpdatingProjectStatus}
          className={classes.actionBtn}
          color="primary"
          outline
        >
          <Icon path={mdiArchiveOutline} size={1} />
          {t('project.archive_project')}
        </Button>
      ) : (
        <Button
          
          onClick={() =>
            dispatch(
              updateProjectStatus({
                projectId: project.id,
                status: 'IN_PROGRESS',
              })
            )
          }
          disabled={isUpdatingProjectStatus}
          className={classes.actionBtn}
          color="primary"
          outline
        >
          <Icon path={mdiArchiveOutline} size={1} />
          {t('project.start_project')}
        </Button>
      )}
      {isArchiveProjectDialogOpen ? (
        <ArchiveProjectDialog
          closeArchiveProjectDialog={() => setIsArchiveProjectDialogOpen(false)}
          handleArchiveProject={() => handleArchiveProject()}
        ></ArchiveProjectDialog>
      ) : null}
    </div>
  ) : null;
};
